(function($) {
    'use strict';

    var ModuleName = 'clp_gplt';

    var Module = function(element, options) {
        this.ele = element;
        this.$ele = $(element);
        this.option = options;
    };

    Module.DEFAULT = {
        openIcon: null,
        closeIcon: null,
        whenOpen: function($module) {
            console.log('whenOpen', $module);
        },
        whenClose: function($module) {
            console.log('whenClose', $module);
        }
    };

    Module.prototype.init = function() {
        var self = this;
        var $this = this.$ele;
        var opts = this.option;
        var $clp_btn = $this.find(".clp-header .clp-btn").length > 0 ? $this.find(".clp-header .clp-btn") : $this.find(".clp-header .clp-title");
        var $clp_btn_inside = $this.find(".clp-body .clp-btn");
        var $header = $this.children('.clp-header');
        var $body = $this.children('.clp-body');
        var openIcon = opts.openIcon;
        var closeIcon = opts.closeIcon;
        if (openIcon === null || closeIcon === null) {
            if ($clp_btn.hasClass('clp-btn')) {
                var icon = $clp_btn.find("span");
                if ($body.is(":visible")) {
                    icon.removeClass("tooladdb");
                    icon.addClass("toolcancelb");
                } else {
                    icon.removeClass("toolcancelb");
                    icon.addClass("tooladdb");
                }
            } else if ($clp_btn.hasClass('clp-title')) {
                if ($body.is(":visible")) {
                    $clp_btn.addClass('clp-open');
                } else {
                    $clp_btn.addClass('clp-close');
                }
            }
        } else {
            var icon = $clp_btn.find("span");
            if ($body.is(":visible")) {
                icon.removeClass();
                icon.addClass(openIcon);
            } else {
                icon.removeClass();
                icon.addClass(closeIcon);

            }
        }
        $this.find('.clp-ticket-btn').on('click', function() {
            $this.find('.clp-ticket-btn').addClass('d-no');
            $this.find('.clp-original-price').addClass('d-no');
            self.clickHandler($clp_btn, $body);
        });
        $this.find('.clp-ticket-cancel-btn').on('click',function(){
            $body.slideUp();
            $this.find('.clp-ticket-btn').removeClass('d-no');
            $this.find('.clp-original-price').removeClass('d-no');
        });
        $header.on('click', function() {
            self.clickHandler($clp_btn, $body);
        });

        if (self.onResize() >= 980 && $this.hasClass('clp-xs')) {
            $header.off('click');
        }

        if ($clp_btn_inside.length > 0) {
            $clp_btn_inside.on('click', function() {
                self.clickHandler($clp_btn, $body);
            });
        }
    };

    //20171214 resize
    Module.prototype.onResize = function() {
        $(window).resize(function() {
            return $(window).width();
        });
    };
    Module.prototype.clickHandler = function($clp_btn, $body) {
        var $this = this.$ele;
        var opts = this.option;
        var openIcon = opts.openIcon;
        var closeIcon = opts.closeIcon;
        if (openIcon === null || closeIcon === null) {
            if (!($(window).width() >= 980 && $this.hasClass('clp-xs'))) {
                if ($clp_btn.hasClass('clp-btn')) {
                    var icon = $clp_btn.find("span");
                    if (icon.hasClass("toolcancelb")) {
                        icon.removeClass("toolcancelb");
                        icon.addClass("tooladdb");
                        $body.slideUp('fast', function() {
                            opts.whenClose($this);
                        });
                        $('html,body').stop().animate({ scrollTop: $this.offset().top - 47 }, 100, 'swing', function() {});
                    } else {
                        icon.removeClass("tooladdb");
                        icon.addClass("toolcancelb");
                        $body.slideDown('fast', function() {
                            opts.whenOpen($this);
                        });
                    }
                } else if ($clp_btn.hasClass('clp-title')) {
                    if ($clp_btn.hasClass("clp-open")) {
                        $clp_btn.removeClass("clp-open");
                        $clp_btn.addClass("clp-close");
                        $body.slideUp('fast', function() {
                            opts.whenClose($this);
                        });
                        $('html,body').stop().animate({ scrollTop: $this.offset().top - 47 }, 100, 'swing', function() {});
                    } else {
                        $clp_btn.removeClass("clp-close");
                        $clp_btn.addClass("clp-open");
                        $body.slideDown('fast', function() {
                            opts.whenOpen($this);
                        });
                    }
                }
            }
        } else {
            var icon = $clp_btn.find("span");
            if (icon.hasClass(closeIcon)) {
                icon.removeClass();
                icon.addClass(openIcon);
                $body.slideDown('fast', function() {
                    opts.whenOpen($this);
                });
            } else {
                icon.removeClass();
                icon.addClass(closeIcon);
                $body.slideUp('fast', function() {
                    opts.whenClose($this);
                });
            }
        }


        var length = $this.closest(".clp_gplt").find(".own");
        var isOpen = 0;
        length.each(function(i) {
            if (($this.closest(".clp_gplt").find(".own").eq(i).attr("data-opt")) == ("open")) {
                isOpen = 1;
            }
        });
        if (isOpen == 0) {
            $this.closest(".clp_gplt").find(".note-danger").css("display", "none");
        }

    };


    $.fn[ModuleName] = function(methods, options) {
        return this.each(function() {
            var $this = $(this);
            var module = $this.data(ModuleName);
            var opts = null;
            if (!!module) {
                if (typeof methods === 'string' && typeof options === 'undefined') {
                    module[methods]();
                } else if (typeof methods === 'string' && typeof options === 'object') {
                    module[methods](options);
                } else {
                    console.log('unsupported options!');
                    throw 'unsupported options!';
                }
            } else {
                opts = $.extend({}, Module.DEFAULT, (typeof methods === 'object' && methods), (typeof options === 'object' && options));
                module = new Module(this, opts);
                module.init();
            }
        });
    };

})(jQuery);


// WEBPACK FOOTER //
// ./magaele/clp_gplt/module.js